import { useParams } from 'react-router'
import { Heading } from '@/components/base/heading'
// @ts-expect-error fragment is used in the query by fragment name
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Item, ItemFragment } from '@/components/items/item'
import { graphql } from '@/gql'
import { useQuery } from '@apollo/client/react'
import { Slimline as Error } from '@/components/error'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { ResultBadge } from '@/components/test_executions/result_badge'
import { TestExecution } from '@/components/test_executions/test_execution'
import { Table } from '@/components/item_test_step_results/table'

const TestExecutionShowQuery = graphql(`
  query TestExecutionShow($id: ID!) {
    testExecutions(filters: { idEq: $id }) {
      nodes {
        id
        equipment { id name }
        pass
      }
    }
  }
`)

export const Show = () => {
  const { id } = useParams() as { id: string }

  const { data, loading, error } = useQuery(TestExecutionShowQuery, { variables: { id } })

  if (loading) return <LoadingSkeleton table title />

  return (<div className="flex flex-col gap-3 grow">
    { error && <Error error={ error } /> }
    { data && <>
      <div className='flex flex-col gap-3'>
        <div className="flex flex-row items-center gap-3">
          <Heading level={ 1 } size="3xl">{ data.testExecutions.nodes[0].equipment.name }</Heading>
          { data.testExecutions.nodes[0].pass !== null && (<ResultBadge pass={data.testExecutions.nodes[0].pass}/>) }
        </div>
      </div>
      <TestExecution id={ data.testExecutions.nodes[0].id}/>
      <Table filters={{testExecutionIdEq: id}}/>
    </> }
  </div>)
}
